
export const actionTypeOf = (namespace: string, actionName: string) => `${namespace}/${actionName}`;
